type PriceField = "price" | "total" | "net" | "cost";

export function isPriceField(value: string): value is PriceField {
  return [
    "price",
    "total",
    "net",
    "cost",
  ].includes(value);
}

type PercentageField = "discount";

export function isPercentageField(value: string): value is PercentageField {
  return [
    "discount",
  ].includes(value);
}
